import React, { useEffect, useState } from 'react';
import {
  Grid,
  styled,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Paper,
  Button,
  Modal,
  Typography,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Box
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PageHeader from '../../../components/PageHeader';
import { Link } from 'react-router-dom';
import { EmailRecipient, EmailStep } from '../../../schema/email_template';
import { api } from '../../../api';
import {
  defaultMapKeywords,
  EmailTemplateMapKeywords,
  mapKeywordsMeaning,
  templateToHtml
} from '../../../util/email';

const mapKeywords = defaultMapKeywords;

const CreateEmailTemplate: React.FC = () => {
  const [stepId, setStepId] = useState<number | null>(null);
  const [recipientId, setRecipientId] = useState<number | null>(null);
  const [subject, setSubject] = useState<string>('');
  const [body, setBody] = useState<string>('');

  const [recipientList, setRecipientList] = useState<EmailRecipient[]>([]);
  const [stepList, setStepList] = useState<EmailStep[]>([]);

  // const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isShowKeywordModal, setIsShowKeywordModal] = useState<boolean>(false);

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // if (isLoading) {
    //   return;
    // }
    // temp disable
    // if (stepId && recipientId && subject) {
    //   setIsLoading(true);
    //   api
    //     .post(`/email_template`, {
    //       step_id: stepId,
    //       recipient_id: recipientId,
    //       subject: subject,
    //       body: body,
    //       is_active: true
    //     })
    //     .then(() => {
    //       navigate('/email-management');
    //     })
    //     .finally(() => setIsLoading(false));
    // }
  };

  useEffect(() => {
    api.get<EmailRecipient[]>(`/email_recipient`).then((res) => {
      const { data } = res;
      setRecipientList(data);
    });
    api.get<EmailStep[]>(`/email_step`).then((res) => {
      const { data } = res;
      setStepList(data);
    });
  }, []);

  return (
    <RootContainer>
      <PageHeader text="เพิ่ม Email" />
      {/* <Container sx={{ mt: 3 }}> */}
      <Button component={Link} to="/email-management" sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        รูปแบบ E-mail
      </Button>

      <Paper>
        <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
          {'เพิ่มข้อมูล'}
        </Typography>

        <Form onSubmit={handleFormSubmit} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <FormControl fullWidth>
                <InputLabel>ขั้นตอน</InputLabel>
                <Select
                  label="ขั้นตอน"
                  variant="outlined"
                  onChange={(e) => setStepId(parseInt(e.target.value))}
                  value={`${stepId}`}
                  autoComplete="off"
                  required
                >
                  {stepList.map((data, index) => (
                    <MenuItem key={index} value={data.id}>
                      {data.step_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel>ถึง</InputLabel>
                <Select
                  label="ถึง"
                  variant="outlined"
                  onChange={(e) => setRecipientId(parseInt(e.target.value))}
                  value={`${recipientId}`}
                  autoComplete="off"
                  required
                >
                  {recipientList.map((data, index) => (
                    <MenuItem key={index} value={data.id}>
                      {data.recipient_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="หัวข้อ"
                variant="outlined"
                placeholder="หัวข้อ"
                onChange={(e) => setSubject(e.target.value ? e.target.value : '')}
                value={subject}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="เนื้อหา (HTML Template)"
                placeholder="เนื้อหา (HTML Template)"
                multiline
                value={body ? body : ''}
                onChange={(e) => setBody(e.target.value ? e.target.value : '')}
                minRows={2}
                maxRows={4}
              />
              <Button
                variant="outlined"
                onClick={() => setIsShowKeywordModal(true)}
                sx={{ marginTop: 2 }}
              >
                แสดงตารางแผนผัง template keywords
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: 4 }}>
            <Grid item xs={6}>
              <Button
                component={Link}
                to="/email-management"
                type="button"
                variant="outlined"
                color="error"
              >
                ยกเลิก
              </Button>
            </Grid>
            <Grid container item xs={6} sx={{ justifyContent: 'end' }}>
              <Button type="submit" variant="contained" color="primary">
                เพิ่มข้อมูล
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Paper>
      <Paper sx={{ mt: 2 }}>
        <Typography variant="h6" sx={{ p: 2, pb: 0, m: 0, textAlign: 'center' }}>
          {'ตัวอย่างเนื้อหา Email'}
        </Typography>
        <Box sx={{ p: 2 }}>
          <Box border={'GrayText'}>
            <iframe
              srcDoc={body ? templateToHtml(body, mapKeywords) : ''}
              style={{
                width: '100%',
                minHeight: 500,
                backgroundColor: '#FFFFFF',
                // transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                // borderRadius: 8,
                // boxShadow:
                //   '0px 1px 1px rgb(100 116 139 / 6%), 0px 1px 2px rgb(100 116 139 / 10%)',
                borderWidth: 0.25,
                borderColor: '#ccc'
                // pointerEvents: 'none'
              }}
              sandbox=""
            ></iframe>
          </Box>
        </Box>
      </Paper>
      {/* </Container> */}
      <Modal
        open={isShowKeywordModal}
        onClose={() => setIsShowKeywordModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalContainer sx={{ p: 0 }}>
          <Table sx={{}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Keyword</TableCell>
                <TableCell>ความหมาย</TableCell>
                <TableCell>ตัวอย่าง</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {EmailTemplateMapKeywords.map((keyword, index) => (
                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component="th" scope="row">
                    {keyword}
                  </TableCell>
                  <TableCell>{keyword in mapKeywords ? mapKeywordsMeaning[keyword] : ''}</TableCell>
                  <TableCell>{keyword in mapKeywords ? mapKeywords[keyword] : ''}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ModalContainer>
      </Modal>
    </RootContainer>
  );
};

export default CreateEmailTemplate;

const RootContainer = styled('div')`
  padding: 24px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;

const ModalContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
  // borderRadius: 16,
  padding: 16,
  width: '70%',
  maxHeight: '80%',
  overflow: 'auto'
}));
